import { ChakraProvider, Container, Heading, Stack, Text, useColorModeValue } from '@chakra-ui/react';
import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import CompanySelect from './helpers/companySelect';
import CombinedForms from './helpers/forms';
import { Helmet } from 'react-helmet';
import { useLookupStore } from '../../context/useStore';

export default function FairForm() {
  const location = useLocation();
  const [company, setCompany] = useState({});
  const [newCompany, setNewCompany] = useState(false);
  const [newContact, setNewContact] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const { pubcodes } = useLookupStore();

  let pubs = location.search;
  pubs = pubs.substring(pubs.indexOf('[') + 1, pubs.indexOf(']')).split(',');

  const selectedPubcodes = pubs.map((pub) => pubcodes.find((pc) => pc.counter === parseInt(pub))).filter(Boolean);
  const eventDescription = selectedPubcodes.map((pub) => pub.omschrijving).join(', ');

  const companySelect = <CompanySelect isClearable={false} maxW={{ lg: '3xl' }} label="Company" setCompany={setCompany} setNewCompany={setNewCompany} setNewContact={setNewContact} />;

  const combinedForms = <CombinedForms newCompany={newCompany} newContact={newContact} company={company} isLoading={isLoading} setIsLoading={setIsLoading} pubs={pubs} />;

  return (
    <ChakraProvider>
      <Helmet>
        <link
          rel="icon"
          href={window.location.href.includes('perfectmoose') ? 'https://perfectmoose.com/favicon.ico' : 'https://schuilenburg.com/wp-content/uploads/2019/03/cropped-schuilenburg-ico.png'}
        />
        <title>{eventDescription ? `Event contact registration - ${eventDescription}` : 'Event contact registration'}</title>
      </Helmet>
      <Container
        py={{
          base: '4',
          md: '8'
        }}
        color="white"
        bgColor={useColorModeValue('sm', 'sm-dark')}
        minH="100vh"
      >
        <Stack spacing="5">
          <Heading as="h1" size="lg">
            Event contact registration
          </Heading>
          {eventDescription && <Text fontSize="lg">{eventDescription}</Text>}
          {companySelect}​{combinedForms}
        </Stack>
      </Container>
    </ChakraProvider>
  );
}
